module.exports = __webpack_public_path__ + "img/uniform.625d23d6.svg";